const icons = {
	testimonial: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 60 60"
			width="20"
			height="20"
		>
			<path
				d="M6,2h48c3.252,0,6,2.748,6,6v33c0,3.252-2.748,6-6,6H25.442L15.74,57.673C15.546,57.885,15.276,58,15,58 c-0.121,0-0.243-0.022-0.361-0.067C14.254,57.784,14,57.413,14,57V47H6c-3.252,0-6-2.748-6-6L0,8C0,4.748,2.748,2,6,2z"
				fill="#f63d3d"
			/>
		</svg>
	),
	remove: (
		<svg
			width="20px"
			height="20px"
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="m50 2.5c-26.199 0-47.5 21.301-47.5 47.5s21.301 47.5 47.5 47.5 47.5-21.301 47.5-47.5-21.301-47.5-47.5-47.5zm24.898 62.301l-10.199 10.199-14.801-14.801-14.801 14.801-10.199-10.199 14.801-14.801-14.801-14.801 10.199-10.199 14.801 14.801 14.801-14.801 10.199 10.199-14.801 14.801z" />
		</svg>
	),
};

export default icons;
